import {environment} from '@/config/environment';

export const appConfig = {
    baseUrl: environment.VITE_BASE_URL ?? '',
    isHybridApp: __IS_HYBRID_APP__,
    get isLocalDevelopment(): boolean {
        // Check if current hostname is a local development URL (*.local domains)
        return (
            typeof window !== 'undefined' &&
            window.location.hostname.endsWith('.local') &&
            !!environment.VITE_DEV_BASE_URL
        );
    },
    get isZrokShare(): boolean {
        // Check if current hostname is a Zrok share URL (*.share.deskly.live)
        // These are used for sharing local development environments
        return (
            typeof window !== 'undefined' && window.location.hostname.endsWith('.share.deskly.live')
        );
    },
    // Getter, not a fixed value: MS Teams is only known at runtime, so headers are rebuilt per request.
    get defaultApiRequestHeaders(): Record<string, string> {
        return getDefaultRequestHeaders();
    },
};

// Web app inside MS Teams is both `webapp` and `ms-teams`, so the header is a comma-separated list.
function getClientIdentifiers(): string[] {
    const identifiers: string[] = [__IS_HYBRID_APP__ ? 'hybrid-app' : 'webapp'];

    if (isInMSTeams()) {
        identifiers.push('ms-teams');
    }

    return identifiers;
}

function isInMSTeams(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    const inUrl = new URLSearchParams(window.location.search).get('inMSTeams') === 'true';

    return inUrl || sessionStorage.getItem('isMSTeams') === 'true';
}

function getDefaultRequestHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
        'client-identifier': getClientIdentifiers().join(','),
        'x-app-version': environment.VITE_APP_VERSION ?? 'unknown',
    };

    if (import.meta.env.MODE === 'app') {
        headers['ngrok-skip-browser-warning'] = 'true';
    }

    return headers;
}
